import React, { useEffect, useState } from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { baseUrl } from "../../../helper/urls";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const getNext30DaysCalendar = () => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() + 1);
  const dates = [];

  for (let i = 0; i < 30; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(new Date(date));
  }

  const firstWeekday = dates[0].getDay();
  const calendar = [];
  let week = new Array(firstWeekday).fill(null);

  for (let date of dates) {
    week.push(date);
    if (week.length === 7) {
      calendar.push(week);
      week = [];
    }
  }

  if (week.length > 0) {
    while (week.length < 7) week.push(null);
    calendar.push(week);
  }

  return calendar;
};

const Calendar = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const calendar = getNext30DaysCalendar();
  const location = useLocation();
  const counselorId = location.state?.counselorId;
  const studentId = location.state?.studentId;
  const reqId = location.state?.reqId;
  const UnscheduledSlot = location.state?.UnscheduledSlot;
  const rescheduleId = location.state?.rescheduleId || null;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [allSlots, setAllSlots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedSlotsID, setSelectedSlotsID] = useState([]);
  const [slotWarning, setslotWarning] = useState("");

  // 🔁 Convert UTC to Local Timezone
  // const convertSlotsToStudentTimezone = (slots) => {
  //   const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   return slots.map((slot) => {
  //     const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
  //     const endLocal = moment(startLocal).add(slot.duration, "minutes");
  //     console.log(`startLocal.format("YYYY-MM-DD")`, slot, startLocal.format("YYYY-MM-DD"))
  //     return {
  //       ...slot,
  //       date: startLocal.format("YYYY-MM-DD"),
  //       start_time: startLocal.format("hh:mm A"),
  //       end_time: endLocal.format("hh:mm A"),
  //       time_zone: studentTimeZone,
  //     };
  //   });
  // };
  const convertSlotsToStudentTimezone = (slots) => {
    return slots.map((slot) => {
      const startUTC = moment.utc(slot.utcTime);
      const endUTC = moment.utc(slot.utcTime).add(slot.duration, "minutes");

      return {
        ...slot,
        date: startUTC.format("YYYY-MM-DD"),
        start_time: startUTC.format("hh:mm A"),
        end_time: endUTC.format("hh:mm A"),
        time_zone: "UTC",
      };
    });
  };


  //   const convertSlotsToStudentTimezone1 = (slot) => {
  //   const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  //   const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
  //   const endLocal = moment(startLocal).add(slot.duration, "minutes");

  //   const dateFormatted = startLocal.format("DD MMM"); // 01 Aug
  //   const start_time = startLocal.format("hh:mm A");   // 02:30 AM
  //   const end_time = endLocal.format("hh:mm A");       // 03:30 AM

  //   return `${dateFormatted} • ${start_time}–${end_time} ${studentTimeZone}`;
  // };
  const convertSlotsToStudentTimezone1 = (slot) => {
    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startLocal = moment.utc(slot.utcTime).tz(studentTimeZone);
    const endLocal = moment(startLocal).add(slot.duration, "minutes");

    const dateFormatted = startLocal.format("DD MMM");
    const start_time = startLocal.format("hh:mm A");
    const end_time = endLocal.format("hh:mm A");
    const tzAbbr = startLocal.format("z");

    return `${dateFormatted} • ${start_time}–${end_time} (${tzAbbr})`;
  };


  const fetchCounselorSlotsByID = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/slots/counselor/${counselorId}/${reqId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const converted = convertSlotsToStudentTimezone(response.data || []);
      setAllSlots(converted);
      // setAllSlots(response.data );
      setLoading(false);
    } catch (error) {
      setError("Error fetching slots");
      setLoading(false);
      toast.error("Api Failed");
    }
  };

  useEffect(() => {
    fetchCounselorSlotsByID();
  }, []);

  const filteredSlots = selectedDate
    ? allSlots.filter(
      (slot) => slot.date === selectedDate.toISOString().split("T")[0]
      // &&  slot.is_available === 1
    )
    : [];

  const dateStats = allSlots.reduce((acc, slot) => {
    if (!acc[slot.date]) acc[slot.date] = { total: 0, available: 0 };
    acc[slot.date].total += 1;
    if (slot.is_available === 1) acc[slot.date].available += 1;
    console.log(acc, "ddddddddddddddddddddd");
    return acc;
  }, {});

  const filteredAvailableDates = new Set(
    Object.entries(dateStats)
      .filter(([_, data]) => data.available > 0)
      .map(([date]) => date)
  );

  const handleSlotClick = (slot) => {
    console.log('slot data::::::::::::::', slot)
    const isSelected = selectedSlots.some((s) => s.id === slot.id);
    if (isSelected) {
      setSelectedSlots((prev) => prev.filter((s) => s.id !== slot.id));
      setSelectedSlotsID((prev) => prev.filter((id) => id !== slot.id));
      setslotWarning("");
    } else {
      if (selectedSlots.length >= UnscheduledSlot) {
        setslotWarning(`You can select only ${UnscheduledSlot} slot.`);
        return;
      }
      setSelectedSlots((prev) => [...prev, slot]);
      setSelectedSlotsID((prev) => [...prev, slot.id]);
      setslotWarning("");
    }
  };

  const isSlotSelected = (slotId) => selectedSlotsID.includes(slotId);

  const handleDelete = (slot) => {
    const isSelected = selectedSlots.some((s) => s.id === slot.id);
    if (isSelected) {
      setSelectedSlots((prev) => prev.filter((s) => s.id !== slot.id));
      setSelectedSlotsID((prev) => prev.filter((id) => id !== slot.id));
      setslotWarning("");
    }
  };

  const [bookSlotApiLoading, setBookSlotApiLoading] = useState(false);

  const BookSlotApi = async () => {
    if (selectedSlotsID.length === 0) {
      // alert("Please select at least one slot to book.");
      toast.error("Please select at least one slot to book.");

      return;
    }
    setBookSlotApiLoading(true);

    try {
      const response = await axios.post(
        `${baseUrl}/bookings/create`,
        {
          slotIds: selectedSlotsID,
          studentId,
          counselorId,
          reqId,
          rescheduleId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Slots booked successfully!");
      toast.success("You will be redirected to pending bokking list");
      setSelectedSlots([]);
      setSelectedSlotsID([]);
      fetchCounselorSlotsByID();
      setTimeout(() => {
        navigate("/student-requested-slot-list");
      }, 500);
      // alert("Slots booked successfully!");
    } catch (err) {
      console.error("Error booking slot:", err);
      const errMessage = err?.response?.data?.message ?? "Unexpected Error"
      Swal.fire({
        icon:"error",
        text:errMessage,

      })
      // toast?.error(errMessage);
      // toast.error("Api Failed");


    } finally {
      setBookSlotApiLoading(false); // end loading
    }
  };

  const convertAlreadySelectedSlots = (slots) => {
    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return slots.map((slot) => {
      const localStart = moment.utc(slot.utcTime).tz(studentTimeZone);
      const localDate = localStart.format("YYYY-MM-DD");
      const localTime = localStart.format("HH:mm");

      return {
        ...slot,
        localDate,
        localTime,
      };
    });
  };

  const [alreadySelectedSlots, setAlreadySelectedSlots] = useState([]);
  const [bookedSlotMap, setBookedSlotMap] = useState(new Map());
  const isSlotBooked = (slot) => {
    const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localStartTime = moment
      .utc(slot.utcTime)
      .tz(studentTimeZone)
      .format("HH:mm");
    const localDate = moment
      .utc(slot.utcTime)
      .tz(studentTimeZone)
      .format("YYYY-MM-DD");
    // console.log(bookedSlotMap, "llllllllllllll");
    // console.log(slot, "lllllllslotlllllll");
    // console.log(bookedSlotMap.has(localDate), "llllllllllllll");
    // console.log(
    //   bookedSlotMap.get(localDate).includes(localStartTime),
    //   "llllllllllllll"
    // );
    return (
      bookedSlotMap.has(localDate) &&
      bookedSlotMap.get(localDate)?.includes(localStartTime)
    );
  };

  const fetchAlreadySelectedSlotsApi = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/slots/counselor/byStudent/${counselorId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const converted = convertAlreadySelectedSlots(response.data.data || []);
      setAlreadySelectedSlots(converted);

      // Create a map: { "YYYY-MM-DD": ["08:00", "09:00", ...] }
      const map = new Map();
      converted.forEach((slot) => {
        if (!map.has(slot.localDate)) {
          map.set(slot.localDate, []);
        }
        map.get(slot.localDate).push(slot.localTime);
      });

      setBookedSlotMap(map);
    } catch (error) {
      console.error("Error fetching already selected slots", error);
      toast.error("Api Failed");
    }
  };

  useEffect(() => {
    fetchAlreadySelectedSlotsApi();
  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />

      <Box sx={{ display: "flex", width: "100%", gap: 2 }}>
        {/* Calendar Section */}
        <Box p={2} sx={{ width: "65%", bgcolor: "#fff", borderRadius: 2 }}>
          <Typography
            variant="body1"
            mb={2}
            sx={{
              width: "100%",
              textAlign: "center",
              fontWeight: "bold",
              color: "#124178",
            }}
          >
            Avoid booking all slots at once-schedule as you progress on your
            sessions{" "}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body1" mb={2}>
              {selectedDate?.toDateString()}
            </Typography>
            <Typography variant="body1" mb={2} color="warning">
              You can book only {UnscheduledSlot} slots
            </Typography>
          </Box>

          {/* <Box display="flex" sx={{ border: "1px solid #ccc" }}> */}
          <Box display="flex">
            {daysOfWeek.map((day, index) => (
              <Box
                key={day}
                flex={1}
                textAlign="center"
                pb={1}
                sx={{
                  borderTop: "1px solid #ccc",
                  borderBottom: "1px solid #ccc",
                  borderLeft: "1px solid #ccc",
                  borderRight:
                    index == daysOfWeek.length - 1 && "1px solid #ccc",
                  fontWeight: "bold",
                }}
              >
                {day}
              </Box>
            ))}
          </Box>

          {calendar.map((week, rowIndex) => (
            <Box key={rowIndex} display="flex">
              {week.map((date, colIndex) => {
                const dateKey = date?.toISOString().split("T")[0];
                const stats = dateStats[dateKey];
                console.log("stats:date ", stats);

                return (
                  <Box key={colIndex} flex={1} p={0}>
                    <Box
                      onClick={() =>
                        date && stats?.total > 0 ? setSelectedDate(date) : null
                      }
                      sx={{
                        height: 100,
                        bgcolor:
                          selectedDate &&
                            date?.toDateString() === selectedDate.toDateString()
                            ? "rgba(33, 150, 243, 0.2)"
                            : !date
                              ? "#fff"
                              : stats
                                ? stats.available === 0
                                  ? "#f8d7da" // fully booked - red
                                  : stats.available < stats.total
                                    ? "#bfefd2" // partially booked - light green
                                    : "#ffffff" // all available
                                : "#f0f0f0",

                        // bgcolor:
                        //   selectedDate &&
                        //   date?.toDateString() === selectedDate.toDateString()
                        //     ? "rgba(33, 150, 243, 0.2)" // 🔵 Selected
                        //     : !date
                        //     ? "#fff"
                        //     : stats
                        //     ? stats.available === 0
                        //       ? "#bfefd2" // 🔴 All slots booked
                        //       : "#fff" // ✅ Has available slots
                        //     : "#f0f0f0", // ⚪️ No slots at all
                        borderBottom: "1px solid #ccc",
                        borderLeft: "1px solid #ccc",
                        borderRight:
                          colIndex === week.length - 1
                            ? "1px solid #ccc"
                            : undefined,
                        position: "relative",
                        cursor:
                          date && stats?.total > 0 ? "pointer" : "not-allowed",
                        opacity: date && stats?.total > 0 ? 1 : 0.6,
                      }}
                    >
                      {date && (
                        <Box sx={{ p: 1 }}>
                          <Typography
                            sx={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            {date.toLocaleDateString("en-US", {
                              month: "short",
                              day: "2-digit",
                              year: "numeric",
                            })}
                          </Typography>
                        </Box>
                      )}

                      {/* {date && stats && (
                        <Box sx={{ position: "absolute", bottom: 1, left: 10 }}>
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "10px" }}
                          >
                            T:{stats.total} B:{stats.total - stats.available} A:
                            {stats.available}
                          </Typography>
                        </Box>
                      )} */}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          ))}
        </Box>

        {/* Slot Display Sidebar */}

        <Box
          sx={{
            width: "20%",
            bgcolor: "#fff",
            borderRadius: 2,
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: "700px", // or use 100% if parent is fixed
            // height: "100%", // or use 100% if parent is fixed
          }}
        >
          <Typography variant="body2" mb={2} textAlign="center">
            {selectedDate
              ? "Available Slots on " +
              `${selectedDate.toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              })}`
              : "Select a date to view slots"}
          </Typography>

          <Box
            sx={{
              overflowY: "auto",
              flexGrow: 1,
              pr: 1,
            }}
          >
            {loading ? (
              <Typography>Loading...</Typography>
            ) : error ? (
              <Typography color="error">{error}</Typography>
            ) : filteredSlots.length > 0 ? (
              filteredSlots.map((slot) => {
                const booked = isSlotBooked(slot);

                {
                  /* if (booked || slot.is_available) {
                  console.log("jhgjshdgfhjsdgjh"); */
                }
                return (
                  <Box
                    key={slot.id}
                    onClick={() => !booked && handleSlotClick(slot)}
                    sx={{
                      mb: 1,
                      p: "8px",
                      border: "1px solid #ccc",
                      borderRadius: 1,
                      bgcolor: booked
                        ? "#f0f0f0"
                        : isSlotSelected(slot.id)
                          ? "#d0f0c0"
                          : "#fff",
                      cursor: booked ? "not-allowed" : "pointer",
                      opacity: booked ? 0.6 : 1,
                    }}
                  >
                    <Typography variant="body2">
                      {slot.start_time} - {slot.end_time} (UTC)
                      {booked && " (Booked)"}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: "0.75rem" }} >
                      {convertSlotsToStudentTimezone1(slot)}
                      {/* 01 Aug • 02:30–03:30 AM (UTC) */}

                    </Typography>
                    {/* <Typography variant="caption" color="text.secondary">
                      {slot.type}
                    </Typography> */}
                  </Box>
                );
                {
                  /* } */
                }

                {
                  /* return null; // Don't render anything if condition fails */
                }
              })
            ) : selectedDate ? (
              <Typography textAlign="center">No slots available.</Typography>
            ) : null}
          </Box>
        </Box>

        {/* <Box sx={{ width: "20%", bgcolor: "#fff", borderRadius: 2, p: 2 }}>
          <Typography variant="body1" mb={2}>
            {selectedDate ? (
              <>
                <Typography
                  variant="body2"
                  sx={{ width: "100%", textAlign: "center" }}
                >
                  Available Slots on
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ width: "100%", textAlign: "center" }}
                >
                  {selectedDate.toDateString()}
                </Typography>
              </>
            ) : (
              <Typography
                variant="body2"
                sx={{ width: "100%", textAlign: "center" }}
              >
                Select a date to view slots
              </Typography>
            )}
          </Typography>

          {loading ? (
            <Typography>Loading...</Typography>
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : filteredSlots.length > 0 ? (
            filteredSlots.map((slot) => {
              const booked = isSlotBooked(slot);

              return (
                <Box
                  key={slot.id}
                  onClick={() => {
                    if (!booked) handleSlotClick(slot);
                  }}
                  sx={{
                    mb: 1,
                    p: "8px",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    bgcolor: booked
                      ? "#f0f0f0"
                      : isSlotSelected(slot.id)
                      ? "#d0f0c0"
                      : "#fff",
                    cursor: booked ? "not-allowed" : "pointer",
                    opacity: booked ? 0.6 : 1,
                  }}
                >
                  <Typography variant="body2">
                    {slot.start_time} - {slot.end_time}
                    {booked && " (Booked)"}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {slot.type}
                  </Typography>
                </Box>
              );
            })
          ) : selectedDate ? (
            <Typography
              variant="body2"
              sx={{ width: "100%", textAlign: "center" }}
            >
              No slots available.
            </Typography>
          ) : null}
        </Box> */}

        {/* Selected Slots */}

        <Box
          sx={{
            width: "15%",
            bgcolor: "#fff",
            borderRadius: 2,
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: "700px",
          }}
        >
          <Typography
            variant="body2"
            sx={{ width: "100%", textAlign: "center" }}
          >
            Selected Slots: {selectedSlots.length}
          </Typography>

          <Box
            sx={{
              overflowY: "auto",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              mt: 2,
              gap: 1,
              flexGrow: 1,
            }}
          >
            <Box sx={{ width: "100%" }}>
              {selectedSlots.map((slot) => (
                <Chip
                  key={slot.id}
                  variant="outlined"
                  onDelete={() => handleDelete(slot)}
                  sx={{ height: "auto", mb: 1 }}
                  label={
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                    >
                      <Typography variant="caption">{slot.date} (UTC)</Typography>
                      <Typography variant="caption">
                        {slot.start_time} - {slot.end_time}
                      </Typography>
                    </Box>
                  }
                />
              ))}
            </Box>
          </Box>

          <Box mt={"auto"}>
            <Button
              variant="contained"
              color="primary"
              onClick={BookSlotApi}
              fullWidth
              disabled={bookSlotApiLoading}
              sx={{
                borderRadius: 2,
                fontWeight: "400",
                textTransform: "none",
                fontSize: "16px",
                py: 1,
              }}
            >
              {bookSlotApiLoading ? "Booking..." : "Book Now"}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Calendar;
